module.exports = __webpack_public_path__ + "files/93662c02a28b39bbde0647f6ab24e2a2.png";